import { Popover } from 'antd';
import React, { FC } from 'react';
import { formatNumWithKMBAlt } from 'utils/helperMethods';

interface Props {
    item: any;
    style: React.CSSProperties;
    overlayKeyMapping: overlayType[];
    pre?: string;
    popoverContentClassName?: string;
}

type overlayType = {
    label: string;
    dataKey: string;
};

const commonStyle: React.CSSProperties = {
    marginBlock: 10,
    display: 'block',
    borderRadius: 4,
    position: 'relative',
};

const CalenderEventItem: FC<Props> = ({
    item,
    style,
    overlayKeyMapping,
    pre = '',
    popoverContentClassName = 'min-w-[194px] max-w-[300px] flex flex-col gap-2',
}) => {
    const { infoData = {} } = item;
    //there can be some additional values coming here,hence not hardcoding
    const content = (
        <div className={popoverContentClassName}>
            {overlayKeyMapping.map((item, index) => {
                return (
                    <p key={item.label} className="flex justify-between gap-2 text-greyFont font-xxs">
                        <span>{item.label}</span>
                        <span className="font-medium text-right">
                            {infoData[item.dataKey] === '' ||
                            isNaN(Number(infoData[item.dataKey])) ||
                            item.dataKey === 'division'
                                ? infoData[item.dataKey]
                                : pre + formatNumWithKMBAlt(Number(infoData[item.dataKey]), 2, 2) || ''}
                        </span>
                    </p>
                );
            })}
        </div>
    );
    return (
        <div className="z-[2] group h-2 hover:z-[3]" style={{ ...commonStyle, ...style }}>
            <Popover
                open={
                    overlayKeyMapping && Array.isArray(overlayKeyMapping) && overlayKeyMapping.length > 0
                        ? undefined
                        : false
                } //dont show popup if hoverdata is empty
                destroyTooltipOnHide
                overlayInnerStyle={{ position: 'relative' }}
                placement="topLeft"
                showArrow={false}
                content={content}
            >
                <div
                    style={{ background: item.style?.background }}
                    className="hidden absolute left-0 rounded right-0 min-h-[1.75rem] p-[6px] group-hover:block"
                >
                    <p className="whitespace-nowrap overflow-hidden text-ellipsis font-xs text-white  ">
                        {infoData?.promoMech}
                    </p>
                </div>
            </Popover>
        </div>
    );
};

export default CalenderEventItem;
